import { render, staticRenderFns } from "./ContentPlaceholder.vue?vue&type=template&id=234d5a75"
import script from "./ContentPlaceholder.vue?vue&type=script&lang=js"
export * from "./ContentPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./ContentPlaceholder.vue?vue&type=style&index=0&id=234d5a75&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports